import Vue from "vue";
import VueRouter from "vue-router";
// import LoginPage from "./../views/LoginPage";

import AccessPage from "./../views/AccessPage/AccessPage";
import TheLogin from "./../views/AccessPage/TheLogin";
import ThePassword from "./../views/AccessPage/ThePassword";
import TheRegistration from "./../views/AccessPage/TheRegistration";

import ChangePassword from "./../views/ChangePassword";
import DeleteUser from "./../views/DeleteUser";
import ConfermaUtente from "./../views/ConfermaUtente";
import NotFound from "./../views/NotFound";
import RecoveryPassword from "./../views/RecoveryPassword";

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/account/data', meta: { requiresAuthenticated: true }},
  // { path: '/login', component: LoginPage, meta: { requiresUnauthenticated: true } },
  {
    path: '/login',
    component: AccessPage,
    meta: { from: "agency" },
    children: [
      {
        path: "",
        component: TheLogin,
      
        meta: {
          requiresUnauthenticated: true,
          from: "agency"
        },
      },  
      {
        path: "registration",
        component: TheRegistration,
        meta: {
          requiresUnauthenticated: true,
          from: "agency"
        },
      },  
      {
        path: "password",
        component: ThePassword,
        meta: { requiresUnauthenticated: true },
      },  
    ]
  },
  {
    path: '/login-models',
    component: AccessPage,
    meta: { from: "models" },
    children: [
      {
        path: "",
        component: TheLogin,
      
        meta: {
          requiresUnauthenticated: true,
          from: "models"
        },
      },  
      {
        path: "registration",
        component: TheRegistration,
        meta: {
          requiresUnauthenticated: true,
          from: "models"
        },
      },  
      {
        path: "password",
        component: ThePassword,
        meta: { requiresUnauthenticated: true },
      },  
    ]
  },
  { path: '/cambia-password', component: ChangePassword, meta: { requiresUnauthenticated: true } },
  { path: '/recupera-password', component: RecoveryPassword, meta: { requiresUnauthenticated: true } },
  { path: '/elimina-profilo', component: DeleteUser },
  { path: '/conferma-email', component: ConfermaUtente, meta: { requiresUnauthenticated: true } },
  { path: '*', component: NotFound, redirect: '/account/data', }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { y: 0 }
  },
});

import store from "../store/index.js";
router.beforeEach( async (to, from, next) => {
  
  if(to.path == "/conferma-email"){
    next();
    return
  }
  

  if(!store.getters.isAuthenticated && store.getters.try_login_one_time == false){
    await store.dispatch('tryLogin')    
    await store.dispatch("user/loadUser");    
    store.commit("try_login_one_time", true);
  }

  if(to.path == "/elimina-profilo"){
    next();
    return
  }

  if ( to.meta.requiresUnauthenticated && store.getters.isAuthenticated ) {
    next("/account/data");
  } else if( to.meta.requiresAuthenticated && !store.getters.isAuthenticated) {

    next('/login?target='+to.path);
  } else {
    store.commit("main_loader", false);
    next();
  }
  
})

export default router;
